module.exports = "/assets/data/20a0dd7dd0b1f6862f103e8d12471a79-NE29.data.json";